import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Dialog, Radio, Popup, Image, List } from 'antd-mobile'
import { YenItem, CountItem } from '../../components_renew/Confirm/Items'
import { AddressEntry } from '../Address/AddressEntry'
import { ConfirmBar } from '../../components_renew/Confirm/ConfirmBar'
import { Container, Wrapper, Header } from '../../components_renew/Layout'

import {
  requestDeliveryData, requestDeliveryUnsubscriptionData,
  setDeliveryAmount,
  setDeliveryCoupon,
} from '../../actions/deliveryAction'
import { requestCouponData } from '../../actions/couponAction'
import { componentUpdateWithToast } from '../../components_renew/HOC'
import { filterCouponWithProductId } from '../../utils/filterTicketWithProduct'
import { handleCatch, postMessage } from '../../utils'

@withRouter
@connect((state) => {
  let { common, couponData, deliveryData, addressData } = state
  let { loading, errorMessage } = common
  let { deliveryCoupon } = couponData
  // let { ticketList, ticketSelected } = deliveryConfirm
  return {
    loading, errorMessage,
    deliveryCoupon,
    deliveryData,
    addressData,
  }
})
@componentUpdateWithToast
class Confirm extends React.PureComponent {
  state = {
    modalVisible: false,
    couponList: [],
  }

  getParams = () => {
    let { location } = this.props
    let params = new URLSearchParams(location.search)
    return {
      id: params.get('orderId'),
      deliverySubOrderFlag: params.get('deliverySubOrderFlag'),
    }
  }

  componentDidMount () {
    let { dispatch, deliveryCoupon, deliveryData } = this.props

    let { id, deliverySubOrderFlag } = this.getParams()
    // 获取提货数据
    if (!this.props.deliveryData.init) {
      if (deliverySubOrderFlag === '1') {
        dispatch(requestDeliveryUnsubscriptionData({ id }))
      } else {
        dispatch(requestDeliveryData({ id }))
      }
    }
    // 获取券数据
    if (!(this.props.deliveryCoupon.length > 0)) {
      dispatch(requestCouponData())
    } else {
      // 若已有数据，则设置券state
      this.handleCoupon(deliveryData['productId'], deliveryCoupon)
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.deliveryCoupon !== this.props.deliveryCoupon ||
      prevProps.deliveryData !== this.props.deliveryData) {
      // coupon update
      // 若券变更或者提货数据变更，则重新筛选适用该商品的券
      let { deliveryData, deliveryCoupon } = this.props
      this.handleCoupon(deliveryData['productId'], deliveryCoupon)
    }
    console.groupEnd()
  }

  render () {
    let {
      deliveryData,
    } = this.props
    let {
      modalVisible,
      couponList
    } = this.state
    let {
      name, maxAmount, minAmount, init, imgSrc, total, unitPrice, amount
      , couponSelected,
    } = deliveryData
    return <Container>
      <Header>确认提货单</Header>
      <Wrapper>
        {/*<AddressButton addressId={addressId} address={address} onClick={this.onAddressClick} />*/}
        <AddressEntry/>
        <div style={{ background: 'var(--adm-color-background)' }}>
          <Image fallback={<Image height={'128px'} src={imgSrc} width={'100%'}/>}
                 src={imgSrc}
                 width={'100%'}
                 height={'auto'}
          />
          <List>
            <YenItem value={unitPrice}>{name}</YenItem>
            {
              maxAmount > 1
                ? <CountItem value={amount} max={maxAmount} min={minAmount}
                             step={minAmount}
                             onChange={this.onAmountChange}>数量（最多{maxAmount}件）</CountItem>
                : <List.Item extra={1}>
                  数量
                </List.Item>
            }
            <YenItem value={total}>预期费用</YenItem>
            <YenItem value={-couponSelected.price}>代金券抵扣</YenItem>
          </List>
        </div>
        <div className={'p-4 text-gray-500'}>
          * 使用代金券后，一张券只能下单一件商品
        </div>
      </Wrapper>
      <ConfirmBar invalid={!init} value={total}
                  extra={couponList.length > 0
                    ? <div
                      onClick={this.showModal}> 券： {couponSelected['couponDesc']}</div>
                    : null}
                  onSubmit={this.onConfirmSubmit}/>
      <Popup
        visible={modalVisible}
        onClose={this.closeModal}
        showCloseButton
        closeOnMaskClick
        bodyClassName={'p-2'}
      >
        <div className={'text-lg font-bold mb-4'}>请选择用券</div>
        <div className={'flex flex-col max-h-[80vh] overflow-y-auto'}>
          {couponList.map((item, index) => (
            <Radio key={index}
                   className={'mb-4'}
                   checked={item.value === couponSelected.value}
                   onChange={this.onCouponChange.bind(this, item)}>
              {item['couponDesc']}
            </Radio>
          ))}
        </div>
      </Popup>
    </Container>
  }

  handleCoupon = (productId, couponData) => {
    this.setState(
      { couponList: filterCouponWithProductId(productId, couponData) })
  }

  onAmountChange = (amount) => {
    // 选择件数小于0 则 不让修改件数（只能为1）
    if (amount <= 0) return
    this.props.dispatch(setDeliveryAmount(amount))
  }

  showModal = () => {
    this.setState({ modalVisible: true })
  }

  closeModal = () => {
    this.setState({ modalVisible: false })
  }

  onCouponChange = (item) => {
    this.closeModal()
    this.props.dispatch(setDeliveryCoupon(item))
  }

  onConfirmSubmit = () => {
    let { init } = this.props.deliveryData
    let { selectedAddress } = this.props.addressData
    if (!init) {
      return null
    } else if (!selectedAddress) {
      window.toast.info('请选择收货地址')
    }
    let { name, total, amount } = this.props.deliveryData
    Dialog.confirm({
      title: name,
      content: `${amount} 件，共 ${total} 元`,
      onConfirm: this.postData
    })
  }
  // postData
  postData = () => {
    let { id, deliverySubOrderFlag } = this.getParams()
    let { addressData, deliveryData } = this.props
    let { couponSelected } = deliveryData
    let addressId = addressData.selectedAddress['id']
    let config = {
      method: 'post',
      url: deliverySubOrderFlag === '1'
        ? window.API.Delivery.postDeliveryUnsubscriptionOrder
        : window.API.Delivery.postDeliveryOrder,
      data: {
        addressId,
        orderNum: id,
        deliveryNumber: deliveryData['amount'],
        couponId: couponSelected['value']
          ? couponSelected['couponId']
          : undefined,
        couponFlag: couponSelected['value'] ? 1 : 0,
      },
    }
    window.toast.show('下单中...')
    window.axios.request(config).then(() => {
      // window.toast.success('下单成功', 2, () => {
      //   window.postMessage(JSON.stringify({ type: 'close' }), '*')
      // })
      window.toast.hide()
      Dialog.alert({
        title: '付款成功',
        onConfirm: () => {
          postMessage({ type: 'close' })
        },
      })

    }).catch(handleCatch)

  }
}

export default Confirm
